import { render } from "./Table.vue?vue&type=template&id=4673dcb0"
import script from "./Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Table.vue?vue&type=script&setup=true&lang=js"

import "./Table.vue?vue&type=style&index=0&id=4673dcb0&lang=css"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4673dcb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4673dcb0', __exports__)) {
    api.reload('4673dcb0', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=4673dcb0", () => {
    api.rerender('4673dcb0', render)
  })

}


export default __exports__